import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./CardUI";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  Legend,
} from "recharts";
import ChartSkeleton from "../../../../core/components/skeleton/ChartSkeleton";

export default function StockMovementChart({
  selectedYear,
  setSelectedYear,
  allTransactions,
  loading,
}) {
  const [monthMap, setMonthMap] = useState([]);

  useEffect(() => {
    const now = new Date();
    const monthMap = {};

    allTransactions.forEach((t) => {
      const ts = new Date(t.timestamp);
      if (ts.getFullYear() !== selectedYear) return;

      const monthKey = `${ts.getFullYear()}-${String(
        ts.getMonth() + 1
      ).padStart(2, "0")}`;

      if (!monthMap[monthKey])
        monthMap[monthKey] = {
          month: monthKey,
          stockIn: 0,
          stockOut: 0,
          adjustment: 0,
        };

      if (t.type === "Stock in") monthMap[monthKey].stockIn += t.quantity;
      if (t.type === "Stock out") monthMap[monthKey].stockOut += t.quantity;
      if (t.type === "Adjustment") monthMap[monthKey].adjustment += t.quantity;
    });

    const fullYearMonths = Array.from({ length: 12 }, (_, i) => {
      const key = `${selectedYear}-${String(i + 1).padStart(2, "0")}`;
      const isFuture =
        selectedYear > now.getFullYear() ||
        (selectedYear === now.getFullYear() && i > now.getMonth());

      const existing = monthMap[key];

      return {
        month: new Date(`${key}-01`).toLocaleString("default", {
          month: "short",
        }),
        stockIn: isFuture ? null : existing?.stockIn || 0,
        stockOut: isFuture ? null : existing?.stockOut || 0,
        adjustment: isFuture ? null : existing?.adjustment || 0,
      };
    });

    setMonthMap(fullYearMonths);
  }, [selectedYear, allTransactions]);

  return (
    <Card>
      <CardHeader className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <CardTitle className="text-lg font-semibold">
            📈 Stock Movement Trends ({selectedYear})
          </CardTitle>
        </div>
      </CardHeader>

      <CardContent>
        {loading ? (
          <ChartSkeleton />
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={monthMap}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="stockIn"
                stroke="#10b981"
                connectNulls={false}
                name="Stock In"
              />
              <Line
                type="monotone"
                dataKey="stockOut"
                stroke="#ef4444"
                connectNulls={false}
                name="Stock Out"
              />
              {/* <Line
              type="monotone"
              dataKey="adjustment"
              stroke="#f59e0b"
              connectNulls={false}
              name="Adjustments"
            /> */}
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
